export enum JsonFieldType {
  string = "string",
  number = "number",
  integer = "integer",
  boolean = "boolean",
  object = "object",
  array = "array",
}

export const NULL = "null"
export type NullableJsonFieldType<T extends JsonFieldType> =
  | T
  | [T, typeof NULL]
  | [typeof NULL, T]

type JsonBase<T extends JsonFieldType> = {
  type: NullableJsonFieldType<T>
  description?: string
}

export const JSON_STRING_FORMATS = [
  "date-time",
  "date",
  "time",
  "duration",
  "email",
  "hostname",
  "ipv4",
  "ipv6",
  "uuid",
] as const

export type JsonStringFormat = (typeof JSON_STRING_FORMATS)[number]

export type JsonString = JsonBase<JsonFieldType.string> & {
  minLength?: number
  maxLength?: number
  format?: JsonStringFormat
  enum?: string[]
}

export type JsonNumber = JsonBase<JsonFieldType.number> & {
  minimum?: number
  maximum?: number
  enum?: number[]
}

export type JsonInteger = JsonBase<JsonFieldType.integer> & {
  minimum?: number
  maximum?: number
  enum?: number[]
}

export type JsonBoolean = JsonBase<JsonFieldType.boolean>

export type JsonObject = JsonBase<JsonFieldType.object> & {
  properties: Record<string, JsonField>
  required: string[]
  additionalProperties: false
}

export type JsonArray = JsonBase<JsonFieldType.array> & {
  items: JsonField
  minItems?: number
  maxItems?: number
}

export type JsonField =
  | JsonString
  | JsonNumber
  | JsonInteger
  | JsonBoolean
  | JsonObject
  | JsonArray

export function defaultField(type: JsonFieldType): JsonField {
  switch (type) {
    case JsonFieldType.string:
      return { type }
    case JsonFieldType.number:
      return { type }
    case JsonFieldType.integer:
      return { type }
    case JsonFieldType.boolean:
      return { type }
    case JsonFieldType.object:
      return {
        type,
        properties: {},
        required: [],
        additionalProperties: false,
      }
    case JsonFieldType.array:
      return {
        type,
        items: { type: JsonFieldType.string },
      }
  }
}
